export default __webpack_public_path__ + "static/media/antifreeze1.86bc09a6.webp";